import { IconProps } from "../../utils/global-types/global-types";

const PreviewIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_3995_61686)">
        <g fill="currentColor" clipPath="url(#clip1_3995_61686)">
          <path d="M9 2.7C3.6 2.7 0 9 0 9s3.6 6.3 9 6.3S18 9 18 9s-3.6-6.3-9-6.3m0 10.8a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"></path>
          <path d="M7.2 8.1a.9.9 0 0 0 .641-1.53c.353-.168.742-.27 1.159-.27A2.7 2.7 0 1 1 6.3 9c0-.417.102-.807.27-1.159.163.16.385.259.63.259"></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3995_61686">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
        <clipPath id="clip1_3995_61686">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PreviewIcon;
